import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import NoRecordFound from "../NoRecordFound";
import { websiteListPropType } from "../../PropTypes/WebsitePropTypes";
import { debounce } from "lodash";
import { getDomainListWithDetailsService } from "../../Services/DomainService/DomainList";
import { useNavigate } from "react-router-dom";
import useWindowScroll from "../../Helpers/useWindowScroll";
import ExpiredPlanWebsiteListTableCellBlock from "../PartnerWebsiteListTableCell/WebsiteExpiredPlan";
import { DomainDetailsService } from "../../Services/DomainService/DomainDetails";
import { getUserDetailsService } from "../../Services/UserAction/LoginActionService";
import "../../Assets/scss/pages/website-list.scss";
import ShowRecordItem from "../ShowRecordItem";
import LodingImg from "../../Assets/img/icon-spinner.svg";
import PaginationComponent from "../Pagination";
import ActiveWebsiteListTableCellBlock from "../PartnerWebsiteListTableCell/WebsiteActivePlan";
import { useSearchParams } from "react-router-dom";
import { UserOrderItemPropTypes } from "../../PropTypes/UserOrderDataPropTypes";
import TrialPlanWebsiteListTableCellBlock from "../PartnerWebsiteListTableCell/WebsiteTrialPlan";

import { DomainDeleteService } from "../../Services/DomainService/DomainDelete";

import { domainValidationService } from "../../Services/DomainService/DomainValidationService";
import { EditDomainService } from "../../Services/DomainService/EditDomain";
import TourGuide from "../TourGuide";
import { SET_MESSAGE } from "../../Actions/Types";



// component to render partner dashboard
const PartnerUserDashboardBlock = () => {



    // Redux Data
    const user = useSelector((store: StoreProptypes) => store.user);
    const accessToken = useSelector((store: StoreProptypes) => store.accessToken);
    const websiteList = useSelector((store: StoreProptypes) => store.websiteList);
    const [isDomainLoading, setIsDomainLoading] = useState(false);
    // console.log(`test: user ${JSON.stringify(user, null, 2)}`);

    // Functions
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const windowScrollValue = useWindowScroll('aioa_dashboard-website-list-filter');

    // State
    const [domainList, setDomainList] = useState<websiteListPropType[]>([]);
    const [totalMainRecord, setTotalMainRecord] = useState<number>(0);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);
    const [offset, setOffset] = useState<number>(0);
    const [terms, setTerms] = useState<string>("");
    const [domainFilter, setDomainFilter] = useState<number>(4);
    const [startDate, setStartDate] = useState<string>(``);
    const [endDate, setEndDate] = useState<string>(``);
    const [orderList, setOrderList] = useState<UserOrderItemPropTypes[]>();


    const prevLimitRef = useRef<number>(10);
    const prevDomainFilterRef = useRef<number>(4);

    const [searchParams] = useSearchParams();
    const userUpdate = searchParams.get("user_update");


    const [isMultipleDomain, setIsMultipleDomain] = useState<boolean>(false)
    const [isDeleteDomainConfirmationPopup, setIsDeleteDomainConfirmationPopup] = useState<boolean>(false)
    const [deleteDomainId, setDeleteDomainId] = useState<number>(0)

    const [isEditDomainNameModal, setIsEditDomainNameModal] = useState<boolean>(false);
    const [editWebsiteId, setEditWebsiteId] = useState<number>(0);
    const [editDomainName, setEditDomainName] = useState<string>("");
    const [editTemporaryDomain, setEditTemporaryDomain] = useState<string>("");
    const [isEditDomainConfirmed, setIsEditDomainConfirmed] = useState<boolean>(false)


    useEffect(() => {
        if (accessToken && userUpdate) {
            getUserDetailsService(accessToken, dispatch).then((userRes) => {
                if (userRes.status === 200) {
                    console.log(`User updated`)
                }
            })
        }
    }, [userUpdate]);

    // Pagination Functions
    useEffect(() => {
        setCurrentPage(1);
    }, [limit, terms, domainFilter]);

    useEffect(() => {
        setOffset(0);
    }, [terms, domainFilter]);

    useEffect(() => {
        setOffset(currentPage * limit - limit);
    }, [currentPage, limit]);

    // function to handle search
    const searchChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTerms(e.target.value);
    };

    // throttle function call on user input
    const debouncedSearchChangeHandler = useMemo(() => {
        return debounce(searchChangeHandler, 500);
    }, []);

    // Get Domain List
    useEffect(() => {
        // check if access token exist, limit and filters are unchanged
        if (accessToken && ((limit === prevLimitRef.current) || (domainFilter === prevDomainFilterRef.current))) {
            // service to get domain list
            getDomainListWithDetailsService(accessToken, dispatch, t, setDomainList, limit, offset, terms, domainFilter, startDate, endDate, setTotalMainRecord, setTotalRecord, setIsDomainLoading);
        }
    }, [offset, terms, user]);

    useEffect(() => {
        // check if limit or filters are changed and offset is 0
        if ((limit !== prevLimitRef.current) || (domainFilter !== prevDomainFilterRef.current) && offset === 0) {
            if (accessToken) {
                getDomainListWithDetailsService(accessToken, dispatch, t, setDomainList, limit, offset, terms, domainFilter, startDate, endDate, setTotalMainRecord, setTotalRecord, setIsDomainLoading);
            }
            prevLimitRef.current = limit;
            prevDomainFilterRef.current = domainFilter;
        }
    }, [offset, limit, domainFilter]);

    // function to Set Current Website
    const handleSetCurrentWebsite = (
        websiteID: number // website ID
    ) => {
        // check if access token and website ID exists
        if (accessToken && websiteID) {
            // service to get domain details
            DomainDetailsService(accessToken, websiteID, dispatch).then((res) => {
                // check if response status is ok
                if (res.status === 200) {
                    navigate('/front/widget-settings');
                } else {
                    navigate('/front');
                }
            });
        }
    }
    const handleISEditModelName = (websiteID:number) => {
        const website = domainList.find(d => d.id === websiteID);
        setEditWebsiteId(websiteID)
        setEditDomainName(website?.domain || '')
        setEditTemporaryDomain(website?.temporary_domain || '')
        setIsEditDomainNameModal(true)
    }

    const handleHideEditDomainNameModel = () => {
        setEditWebsiteId(0)
        setEditDomainName("")
        setEditTemporaryDomain("")
        setIsEditDomainNameModal(false)
    }

    const editDomain = () => {
        const cleanedDomainName = editDomainName.replaceAll(" ", "").replace(/\s+/g, '');
        const cleanedTemporaryDomain = editTemporaryDomain.replaceAll(" ", "").replace(/\s+/g, '');
        
        if (cleanedTemporaryDomain && cleanedDomainName === cleanedTemporaryDomain) {
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('alternateWebsiteSameUrl'),
                    "toast_type": "danger"
                }
            })
            return;
        }
        
        domainValidationService(cleanedDomainName, dispatch, t, cleanedTemporaryDomain).then((res) => {
            if (res.states === 200) {
                setIsEditDomainNameModal(false)
                setIsEditDomainConfirmed(true)
            }
        })
    }

    const confirmEditDomain = () => {
        if (accessToken) {
        const cleanedDomainName = editDomainName.replaceAll(" ", "").replace(/\s+/g, '');
        const cleanedTemporaryDomain = editTemporaryDomain.replaceAll(" ", "").replace(/\s+/g, '');
        EditDomainService(accessToken, editWebsiteId, cleanedDomainName, cleanedTemporaryDomain, dispatch, domainList.find(d => d.id === editWebsiteId)?.domain || '').then((res) => {
            // check if response is ok
            if (res.status === 200) {
                setIsEditDomainConfirmed(false)
            }
        })
        }
    }

    // function to hide widget script modal
    const handleHideWidgetScriptConfirmModal = () => {
        setEditWebsiteId(0)
        setEditDomainName("")
        setEditTemporaryDomain("")
        setIsEditDomainNameModal(false)
        setIsEditDomainConfirmed(false)
    }

    useEffect(() => {
    if (user) {
        setIsMultipleDomain(user.is_multiple_domain === 1 ? true : false)
    }
    },[user])

     const handleDeleteDomain = (id:number) => {
        setIsDeleteDomainConfirmationPopup(true)
        setDeleteDomainId(id)
    }

    const handleHideDeleteConfirmationPopup = () => {
        setIsDeleteDomainConfirmationPopup(false)
        setDeleteDomainId(0)
    }

    const handleDeleteDomainAction = () => {
        if (accessToken) {
            DomainDeleteService(accessToken, deleteDomainId, dispatch, domainList.filter(d => d.id !== deleteDomainId)[0].id, domainList.find(d => d.id === deleteDomainId)?.domain || '')
        }
        setIsDeleteDomainConfirmationPopup(false)
    }

    return (
        <>
        <TourGuide />
            <Row>
                <Col xl={12}>
                    <div className="aioa_dashboard-website-list aioa_dashboard-partner-website-list-wrapper tour-partner-dashboard">

                        <div className={`aioa_dashboard-website-list-filter-wrapper ${windowScrollValue}`} id="aioa_dashboard-website-list-filter">

                            <div className="aioa_dashboard-website-list-filter-block">
                                <Form.Label className='d-lg-none'>{t("Search")}</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        placeholder={t("Search Domain").toString()}
                                        aria-label={t("Search Domain").toString()}
                                        type="text"
                                        onChange={debouncedSearchChangeHandler}
                                    />
                                    <InputGroup.Text><i className="material-symbols-outlined" aria-hidden="true">search</i></InputGroup.Text>
                                </InputGroup>
                            </div>

                            <div className="aioa_dashboard-website-list-filter-block">
                                <Form.Label htmlFor='domain_status'>{t("Filter")}</Form.Label>
                                <Form.Select
                                    onChange={(e) => setDomainFilter(parseInt(e.target.value))}
                                    id="domain_status"
                                    aria-label={t("Filter").toString()}
                                    defaultValue={domainFilter ? domainFilter : 4}
                                >
                                    <option value="4">{t("All")}</option>
                                    <option value="10">{t("Active")}</option>
                                    <option value="1">{t("Pending Activation")}</option>
                                    <option value="2">{t("trials")}</option>
                                    <option value="3">{t("Expired")}</option>
                                </Form.Select>
                            </div>
                            <div className="aioa_dashboard-website-list-filter-block">
                                <Form.Label htmlFor='showPages'>{t("Items Per Page")}</Form.Label>
                                <Form.Select
                                    onChange={(e) => setLimit(parseInt(e.target.value))}
                                    id="showPages"
                                    value={limit}
                                    aria-label={t("Items Per Page").toString()}
                                >
                                    <option value="10">{t("10")}</option>
                                    <option value="20">{t("20")}</option>
                                    <option value="40">{t("40")}</option>
                                    <option value="80">{t("80")}</option>
                                    <option value="100">{t("100")}</option>
                                </Form.Select>
                            </div>

                        </div>

                        <div className="aioa_dashboard-table">

                            <div className="aioa_dashboard-table-thead">
                                <div className="aioa_dashboard-table-tr">
                                    <div className="aioa_dashboard-table-th tcw-100 aioa_dashboard-table-cell-sidegap">{t("Sr No")}</div>
                                    <div className="aioa_dashboard-table-th tcw-350 aioa_dashboard-table-cell-sidegap">{t("Domain")}</div>
                                    <div className="aioa_dashboard-table-th tcw-150 text-center aioa_dashboard-table-cell-sidegap">{t("Plan")}</div>
                                    <div className="aioa_dashboard-table-th tcw-150 text-center aioa_dashboard-table-cell-sidegap">{t("Status")}</div>
                                    <div className="aioa_dashboard-table-th tcw-150 text-center aioa_dashboard-table-cell-sidegap">{t("Price(USD)")}</div>
                                    <div className="aioa_dashboard-table-th tcw-150 text-center aioa_dashboard-table-cell-sidegap">{t("Renew Date")}</div>
                                    {(user?.parent_id === 1 || user?.parent_id === 0) && (
                                    <div className="aioa_dashboard-table-th tcw-200 text-center aioa_dashboard-table-cell-sidegap">{t("Manage Plan")}</div>
                                    )}
                                    {/* <div className="aioa_dashboard-table-th tcw-100 text-center aioa_dashboard-table-cell-sidegap">&nbsp;</div>  */}
                                    {(user?.parent_id === 1 || user?.parent_id === 0) && (
                                    <div className="aioa_dashboard-table-th tcw-50 text-center aioa_dashboard-table-cell-sidegap">{t("Action")}</div>
                                    )}
                                </div>
                            </div>

                            <div className="aioa_dashboard-table-body">
                                <div className="aioa_dashboard-table">

                                      {isDomainLoading ? (
      
                        <div className="aioa_dashboard-loader d-flex justify-content-center m-0">
                            <img src={LodingImg} width="50px" alt="" />
                            <span className="visually-hidden">{t("Loading page. Please Do not refresh the page")} </span>
                        </div>
                ) : domainList ? (
                                        <>
                                            {domainList?.length > 0 ? (
                                                <>
                                                    {domainList.map((domain, index) => {
                                                        return (
                                                            <React.Fragment key={domain.id}>
                                                                {(domain.current_package_only && domain.current_package_only.length > 0) ? (
                                                                    <>
                                                                        {domain.current_package_only[0].is_trial_period === 1 ? (
                                                                            <>
                                                                                <TrialPlanWebsiteListTableCellBlock item={domain} key={domain.id} srno={index + 1 + offset} handleSetCurrentWebsite={handleSetCurrentWebsite} handleEditModelName={handleISEditModelName} handleDeleteDomain={handleDeleteDomain}/>
                                                                            </>
                                                                        ) : (
                                                                            <>

                                                                                <ActiveWebsiteListTableCellBlock item={domain} key={domain.id} srno={index + 1 + offset} handleSetCurrentWebsite={handleSetCurrentWebsite} handleDeleteDomain={handleDeleteDomain} handleEditModelName={handleISEditModelName}/>

                                                                            </>
                                                                        )}
                                                                        {/* <ActiveWebsiteListTableCellBlock item={domain} key={domain.id} srno={index + 1 + offset} handleSetCurrentWebsite={handleSetCurrentWebsite} /> */}
                                                                    </>
                                                                ) : (domain.expired_package_detail && domain.expired_package_detail.length > 0) ? (
                                                                    <>
                                                                        <ExpiredPlanWebsiteListTableCellBlock item={domain} key={domain.id} srno={index + 1 + offset} handleSetCurrentWebsite={handleSetCurrentWebsite} handleEditModelName={handleISEditModelName} />
                                                                    </>
                                                                ) : (
                                                                    <>

                                                                    </>
                                                                )}
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                </>
                                            ) : (
                                                <>
                                                    <NoRecordFound joyful={false} imageType={`domain`} noRecordText={`${t('Domain not found')}.`} />
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>

                                        </>
                                    )}

                                </div>
                            </div>

                            <div className="aioa_dashboard-table-pagination-main">
                                <>
                                    <ShowRecordItem
                                        offset={offset}
                                        limit={limit}
                                        totalRecord={totalRecord}
                                    />
                                    <PaginationComponent
                                        currentPage={currentPage}
                                        totalRecords={totalRecord}
                                        itemsPerPage={limit}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </>
                            </div>

                        </div>

                    </div>
                </Col>
                {/* <Col xl={3}>
                    <ManualAccessibilityAuditBlock />
                </Col> */}
            </Row>


             <Modal show={isDeleteDomainConfirmationPopup} className="aioa_dashboard-info-modal" onHide={() => handleHideDeleteConfirmationPopup()} size="lg" fullscreen="lg-down" backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                                {t("delete domain")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="aioa_dashboard-info-modal-content">
                        {t(`are you sure you want to remove`)} &nbsp;
                        <b>{domainList.find(d => d.id === deleteDomainId)?.domain}?</b>
                    </div>
                </Modal.Body>
                        <Modal.Footer>
                            <Button variant="danger" size="lg" onClick={() => handleDeleteDomainAction()}>
                                {t('delete')}
                            </Button>
                            <Button variant="primary" size="lg" onClick={() => handleHideDeleteConfirmationPopup()}>
                                {t('Cancel')}
                            </Button>
                        </Modal.Footer>
                </Modal>

             {/* Edit Domain name popup */}
        <Modal show={isEditDomainNameModal} onHide={() => handleHideEditDomainNameModel()} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>{t('update domain name')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <Form>
                <Form.Label htmlFor="domain">{t("websiteLabel")} <span className="text-danger" aria-hidden="true">*</span></Form.Label>
                <InputGroup className="mt-1 input-group-outline">
                    <Form.Control
                        id="domain"
                        placeholder={`${t("enter domain")}`}
                        aria-label={`${t("enter domain")}`}
                        type="text"
                        size="lg"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEditDomainName(e.target.value)} value={editDomainName}
                    />
                </InputGroup>
                <Form.Label htmlFor="alternate_domain" className="mt-3">{t("alternateWebsiteLabel")}</Form.Label>
                <InputGroup className="mt-1 input-group-outline">
                    <Form.Control
                        id="alternate_domain"
                        placeholder={`${t("alternateWebsitePlaceholder")}`}
                        aria-label={`${t("alternateWebsitePlaceholder")}`}
                        type="text"
                        size="lg"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEditTemporaryDomain(e.target.value)} value={editTemporaryDomain}
                    />
                </InputGroup>
              </Form>
          </Modal.Body>
          <Modal.Footer>
             {/* <Button 
                variant="danger"
                size="lg"
                onClick={() => {
                  setIsEditDomainNameModal(false); // close edit modal
                  handleDeleteDomain(editWebsiteId); // open delete modal
                }}
              >
                {t('delete')}
              </Button> */}
              <Button variant="success" size="lg" onClick={() => editDomain()}>
                  {t('update')}
              </Button>
              <Button variant="primary" size="lg" onClick={() => handleHideEditDomainNameModel()}>
                  {t('Cancel')}
              </Button>
          </Modal.Footer>
        </Modal>

        {/* Confirm Popup for Edit Website */}
        <Modal show={isEditDomainConfirmed} onHide={() => handleHideWidgetScriptConfirmModal()} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>{t('confirm domain')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           <div className='mb-3'>
            <div className="mb-3">
              {t('changing the domain will remove all existing reports, along with any add-on packages and widget settings associated with the current domain')}<br></br>
            </div>
            <div className="mb-3">
              {t('this action cannot be undone')}.<br></br>
            </div>
            <b>{t('do you want to proceed?')}</b>
            </div>
          </Modal.Body>
          <Modal.Footer>
              <Button variant="success" size="lg" onClick={() => confirmEditDomain()}>
                  {t('confirm')}
              </Button>
              <Button variant="primary" size="lg" onClick={() => handleHideWidgetScriptConfirmModal()}>
                  {t('Cancel')}
              </Button>
          </Modal.Footer>
        </Modal>

        </>
    )
}

export default PartnerUserDashboardBlock;
